import React, { useEffect } from "react";
import Image from "next/image";
import styles from "./ExecutiveInformation.module.scss";

const ExecutiveInformation = ({ data, desc,color }) => {

  useEffect(() => {
    document.documentElement.style.setProperty('--link-color', color);
  }, [color]);
  
  return (
    <>
      {data && (
        <div className="container mt-5" data-testid="ei-container-id">
          <div className={styles.exective_session}>
            <div className={styles.executive_info_main}>
              <div className={styles.img_wrap}>
                <Image
                  src={data?.image?.results?.[0]?.fileUrl}
                  width={128}
                  height={128}
                  alt="client"
                />
              </div>
              <div className={styles.text_wrap}>
                <h2>{data?.title}</h2>
                <h6
                  dangerouslySetInnerHTML={{
                    __html: data?.maintitle?.content?.[0]?.content?.[0]?.text,
                  }}
                />
              </div>
            </div>

            <div className={styles.exe_desc}>
              <p dangerouslySetInnerHTML={{ __html: desc }} />
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ExecutiveInformation;
